/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MarketComparisonWritable } from './MarketComparisonWritable';
export type MarketAdjustmentWritable = {
  readonly id?: number;
  market_comparisons: Array<MarketComparisonWritable>;
  deleted_market_comparisons?: Array<number> | null;
  adjustment_selection: MarketAdjustmentWritable.adjustment_selection;
  metric_selection: MarketAdjustmentWritable.metric_selection;
  name: string;
  readonly last_audit_event_id?: string | null;
  is_deleted?: boolean | null;
  readonly deleted_at?: string | null;
  as_of_date: string;
  percentile_selection_a?: number;
  percentile_selection_b?: number;
  specified_adjustment?: string | null;
  market_adjustment?: string | null;
  valuation: number;
};
export namespace MarketAdjustmentWritable {
  export enum adjustment_selection {
    MEDIAN = 'Median',
    MEAN = 'Mean',
    _75TH_PERCENTILE = '75th Percentile',
    _25TH_PERCENTILE = '25th Percentile',
    SELECTION_A = 'Selection A',
    SELECTION_B = 'Selection B',
    SPECIFIED = 'Specified',
    WEIGHTED = 'Weighted',
  }
  export enum metric_selection {
    MARKET_CAP = 'Market Cap',
    ENTERPRISE_VALUE = 'Enterprise Value',
    ENTERPRISE_VALUE_EXCLUDING_OPERATING_LEASES = 'Enterprise Value Excluding Operating Leases',
    LTM_REVENUE = 'LTM Revenue',
    LTM_EBITDA = 'LTM EBITDA',
    NTM_REVENUE = 'NTM Revenue',
    NTM_EBITDA = 'NTM EBITDA',
  }
}

